// TODO: Add tests
export function getLabelKebabCase(strings) {
    const kebabCaseStrings = [];
    strings.forEach((s) => {
        // Remove extra white space, make all letters lower case, and replace space(s) with dashes
        kebabCaseStrings.push(s.trim().toLowerCase().replace(/\s+/g, '-'));
    });
    return kebabCaseStrings.join('-').replace(/[-]+/g, '-');
}
